import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { IChatRoomParticipant } from '@sondermind/utilities/models-chat';

export interface IChatParticipantService {
  getChatParticipantOptions$: () => Observable<IChatRoomParticipant[]>;
}

export const CHAT_PARTICIPANT_SERVICE = new InjectionToken<IChatParticipantService>('CHAT_PARTICIPANT_SERVICE');
